import { IsBoolean, IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class SuccessDto {
    @IsBoolean()
    @IsNotEmpty()
    success: boolean = false;

    @IsString()
    @IsNotEmpty()
    @IsOptional()
    message?: string;

    data?: any;
}
